import React from "react";
import Center from "../../../../widget/common/ui/Center";
import Loader from "../../../../widget/common/ui/Loader";
import Div from "../../../../widget/common/ui/Div";
import { Col, Row } from "react-bootstrap";
import { textCase } from "../../../../service/ui/UI";
import { TextBlock } from "../../../../widget/common/ui/Text";
import { ButtonSingle, ButtonDouble } from "../../../../widget/common/form/Button";
import { MenuMyMessagesList } from "../../../../model/work_profile/MyMessagesModel";
import { CheckBoxRound } from "../../../../widget/common/ui/Checkbox";
import NoData from "../../../../widget/common/ui/NoData";
import AppTranslation from "../../../../service/app_translation/AppTranslation";

type MyMessagesListType = {
  tabName: "none" | "delete" | "add";

  fromChat: boolean;
  loadedStatus: boolean;
  selectedIds: Array<string>;
  messageList: Array<MenuMyMessagesList>;

  selectedId: string;

  handleSubmit: () => void;
  handleCancel: () => void;
  handleItemDelete: (id: string) => void;

  handleItemClick: (detail: MenuMyMessagesList) => void;

  handleClickToggleEdit: (id: string) => void;
  handleSendMessage: (msg: string) => void;
};

const MyMessagesList: React.FC<MyMessagesListType> = ({
  tabName = "none",
  loadedStatus = false,
  fromChat = false,
  selectedIds = [],
  messageList = [],
  selectedId,
  handleSubmit,
  handleCancel,
  handleItemDelete,
  handleItemClick,
  handleClickToggleEdit,
  handleSendMessage,
}) => {
  return (
    <>
      {!loadedStatus ? (
        <Center className="py-3 py-lg-5">{Loader.normal()}</Center>
      ) : (
        <>
          {messageList.length === 0 ? (
            <NoData />
          ) : (
            <Div className="theme-listing fixed-height">
              <Row>
                {messageList.map((message, key) => (
                  <Col
                    key={key}
                    xs={12}
                    lg={messageList.length === 1 ? 12 : 6}
                    className="my-messages-item"
                  >
                    <Div className="py-3 d-flex align-items-center justify-content-between">
                      <div
                        role={tabName === "delete" ? "" : "button"}
                        className="w-100"
                        onClick={() =>
                          tabName === "delete"
                            ? handleItemDelete(message?.group_id!)
                            : handleClickToggleEdit(message?.group_id!)
                        }
                      >
                        <TextBlock
                          maxLine={1}
                          className="mb-1"
                          fontName="bold"
                          textColor="theme-label"
                        >
                          {textCase(message?.title!)}
                        </TextBlock>
                        <TextBlock maxLine={1} textColor="theme-sublabel">
                          {textCase(message?.message!)}
                        </TextBlock>

                        {selectedId === message?.group_id! && (
                          <Div className="mt-2">
                            {fromChat ? (
                              <ButtonDouble
                                title1="edit"
                                title2="send"
                                width={200}
                                height={40}
                                handleClick1={() => handleItemClick(message)}
                                handleClick2={() =>
                                  handleSendMessage(message?.message!)
                                }
                              />
                            ) : (
                              <ButtonSingle
                                handleClick={() => handleItemClick(message)}
                                width={100}
                                height={40}
                              >
                                {AppTranslation.text("edit")}
                              </ButtonSingle>
                            )}
                          </Div>
                        )}
                      </div>
                      {tabName === "delete" && (
                        <CheckBoxRound
                          status={selectedIds.includes(message?.group_id!)}
                        />
                      )}
                    </Div>
                  </Col>
                ))}
              </Row>

              {tabName === "delete" && (
                <Center className="pt-5">
                  <ButtonDouble
                    title1="cancel"
                    title2="submit"
                    width={350}
                    handleClick1={handleCancel}
                    handleClick2={handleSubmit}
                  />
                </Center>
              )}
            </Div>
          )}
        </>
      )}
    </>
  );
};

export default MyMessagesList;
